import { fetchApi } from '@/services/api-client';

export const SCHOOL_YEARS_PATH = '/admin/school-years';

export type SchoolYearStatus = 'planned' | 'active' | 'archived' | 'locked';

export type SchoolYear = {
  id: string;
  code: string;
  name: string;
  startDate: string;
  endDate: string;
  status: SchoolYearStatus;
  studentsPromotedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export const schoolYearsApi = {
  list: () => fetchApi<SchoolYear[]>(SCHOOL_YEARS_PATH),
  getById: (id: string) => fetchApi<SchoolYear>(`${SCHOOL_YEARS_PATH}/${id}`),
  create: (data: { code: string; name: string; startDate: string; endDate: string; status?: SchoolYearStatus }) =>
    fetchApi<SchoolYear>(SCHOOL_YEARS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (
    id: string,
    data: Partial<{
      code: string;
      name: string;
      startDate: string;
      endDate: string;
      status: SchoolYearStatus;
    }>
  ) =>
    fetchApi<SchoolYear>(`${SCHOOL_YEARS_PATH}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),
  promoteStudents: (id: string) =>
    fetchApi<{ alreadyPromoted: boolean; promoted: number }>(`/admin/school-years/${id}/promote-students`, {
      method: 'POST',
    }),
};
